// Login Page - GitHub Only Authentication
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Auth.css';

const Login = () => {
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { signInWithGitHub } = useAuth();

    const handleGitHubLogin = async () => {
        setLoading(true);
        setError('');
        try {
            await signInWithGitHub();
        } catch (err) {
            setError(err.message || 'Error al conectar con GitHub');
            setLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-form-section">
                <Link to="/" className="auth-logo">
                    <div className="auth-logo-icon">⚡</div>
                    <span className="auth-logo-text">Roadmap<span>Platform</span></span>
                </Link>

                <div className="auth-content">
                    <h1>Bienvenido</h1>
                    <p className="auth-subtitle">
                        Conecta con GitHub para acceder a tus proyectos
                    </p>

                    {error && <div className="auth-error">{error}</div>}

                    <button 
                        onClick={handleGitHubLogin} 
                        className="auth-github-btn"
                        disabled={loading}
                    >
                        {/* GitHub Logo */}
                        <svg viewBox="0 0 24 24" fill="currentColor" className="github-icon">
                            <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                        </svg>
                        {loading ? 'Conectando...' : 'Continuar con GitHub'}
                    </button>

                    <div className="auth-info-box">
                        <div className="auth-info-icon">ℹ️</div>
                        <div className="auth-info-text">
                            <strong>¿Por qué GitHub?</strong>
                            <p>Usamos GitHub para autenticación y backups automáticos de tu código. Una cuenta, todo conectado.</p>
                        </div>
                    </div>

                    <div className="auth-features">
                        <div className="auth-feature">
                            <span className="feature-icon">🔐</span>
                            <span>Autenticación segura</span>
                        </div>
                        <div className="auth-feature">
                            <span className="feature-icon">💾</span>
                            <span>Backups automáticos</span>
                        </div>
                        <div className="auth-feature">
                            <span className="feature-icon">🚀</span>
                            <span>Un click para empezar</span>
                        </div>
                    </div>

                    <p className="auth-terms">
                        Al continuar, aceptas los <Link to="/privacy-policy">términos de uso</Link>
                    </p>
                </div>
            </div>

            <div className="auth-visual-section">
                <div className="auth-visual-image">
                    <img
                        src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=1200&fit=crop"
                        alt="Dashboard analytics"
                    />
                </div>
                <div className="auth-visual-overlay"></div>
                <div className="auth-visual-text">
                    <h2>El GitHub de los Roadmaps</h2>
                    <p>Planifica, ejecuta y haz backup de tus proyectos con precisión profesional.</p>
                </div>
            </div>
        </div>
    );
};

export default Login;
